<template>
  <div class="container contain mx-auto display-flex flex-column">
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
  .contain {
    flex-grow: 1;
    padding-top: 140px;

    @include desktop-1200 {
      padding-top: 90px;
    }
  }
</style>
